'use client'

import { useState, type ReactNode } from 'react'

export function ProblemSolutionMobileTabs({
  before,
  after,
}: {
  before: ReactNode
  after: ReactNode
}) {
  const [activeTab, setActiveTab] = useState<'before' | 'after'>('before')

  return (
    <div className="flex w-full flex-col items-center gap-8">
      {/* Segmented Control */}
      <div className="relative flex w-full max-w-xs items-center rounded-full border border-slate-200 bg-slate-100 p-1 dark:border-white/10 dark:bg-white/5">
        <div
          className={`absolute inset-y-1 w-[calc(50%-4px)] rounded-full shadow-sm transition duration-300 ease-out ${
            activeTab === 'before'
              ? 'left-1 bg-white dark:bg-[#202c33]'
              : 'left-[calc(50%)] bg-white dark:bg-emerald-600'
          }`}
        />
        <button
          type="button"
          onClick={() => setActiveTab('before')}
          className={`relative z-10 flex-1 py-2 text-sm font-bold transition-colors duration-200 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-emerald-500/40 ${
            activeTab === 'before'
              ? 'text-slate-900 dark:text-white'
              : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
          }`}
          aria-pressed={activeTab === 'before'}
        >
          Antes
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('after')}
          className={`relative z-10 flex-1 py-2 text-sm font-bold transition-colors duration-200 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-emerald-500/40 ${
            activeTab === 'after'
              ? 'text-slate-900 dark:text-white'
              : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
          }`}
          aria-pressed={activeTab === 'after'}
        >
          Después
        </button>
      </div>

      {/* Content Area */}
      <div className="relative w-full overflow-hidden rounded-3xl border border-slate-200 shadow-xl dark:border-white/10">
        <div
          className={`transition duration-500 ease-in-out ${
            activeTab === 'before' ? 'opacity-100' : 'hidden opacity-0'
          }`}
        >
          <div className="relative">
            <div className="absolute inset-x-0 top-0 z-10 flex items-center justify-center bg-red-500/10 py-2 backdrop-blur-sm">
              <span className="text-xs font-bold uppercase tracking-wider text-red-600 dark:text-red-400">
                Caos Manual
              </span>
            </div>
            {before}
          </div>
        </div>
        <div
          className={`transition duration-500 ease-in-out ${
            activeTab === 'after' ? 'opacity-100' : 'hidden opacity-0'
          }`}
        >
          <div className="relative">
            <div className="absolute inset-x-0 top-0 z-10 flex items-center justify-center bg-emerald-500/10 py-2 backdrop-blur-sm">
              <span className="text-xs font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
                Con LuckAgents
              </span>
            </div>
            {after}
          </div>
        </div>
      </div>
    </div>
  )
}
